import { MultiUserSingleItem } from './MultiUserSingleItem';
export default MultiUserSingleItem;